import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const thorEventStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            padding: "16px 20px 16px 20px",
            boxShadow: "0px 4px 10px rgba(110, 102, 102, 0.2)",
            marginBottom: "20px",
            borderRadius: "0px",
        },
        gridItem: {
            minWidth: "150px",
            paddingTop: "10px",
            fontWeight: 500,
            fontSize: "16px",
        },

        detailsBtn: {
            backgroundColor: "#270ADC",
            color: "white",
            fontWeight: 300,
            fontSize: "15px",
            padding: "8px",
            float: "right",
            "&:hover": {
                backgroundColor: theme.colors.primary.blue600,
            },
        },
        additionalBtnStyles: {
            paddingTop: "4px",
        },
        hide: { visibility: "hidden" },
        subText: {
            marginRight: "5px",
            fontWeight: 400,
        },
        completeText: {
            color: "#156639",
        },
        pendingText: {
            color: "#CA7900",
        },
        grid: { marginRight: "20px" },
        iconSpacing: {
            marginRight: "8px",
        },
        iconContainer: {
            display: "flex",
        },
        new: {
            color: "rgba(179, 0, 33, 1)",
            fontWeight: 500,
            marginTop: "5px",
        },
        image: {
            position: "absolute",
            marginTop: "-7px",
            marginLeft: "10px",
            cursor: "pointer",
        },

        tooltip: {
            backgroundColor: "white",
            color: "rgba(0, 0, 0, 0.87)",
            width: "300px",
            height: "150px",
            fontSize: "16px",
            border: "1px solid #dadde9",
        },
    })
);
